import { BehaviorSubject } from 'rxjs';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LoadingDisplayService {
  isVisible: BehaviorSubject<boolean> = new BehaviorSubject(false);

  constructor() { }

  show() {
    this.isVisible.next(true);
  }

  hide() {
    this.isVisible.next(false);
  }
}
